(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["country-selector-popup"] && !Shopify.designMode) return;
  try {
    
  class CountryRedirectPopup extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('.country-redirect-popup__overlay');
      this.dialog = this.querySelector('.country-redirect-popup__dialog');
      this.closeButton = this.querySelector('.country-redirect-popup__close');
      this.dismissButton = this.querySelector('.country-redirect-popup__dismiss');
      this.acceptButton = this.querySelector('.country-redirect-popup__accept');
      this.flagButton = this.querySelector('.country-redirect-popup__flag-button');
      this.flagImage = this.querySelector('.country-redirect-popup__flag');
      this.flagEmoji = this.querySelector('.country-redirect-popup__flag-emoji');
      this.heading = this.querySelector('.country-redirect-popup__heading');
      this.body = this.querySelector('.country-redirect-popup__body');

      this.cookieName = 'country_redirect_response';
      this.cookieDays = parseInt(this.dataset.cookieDays, 10) || 30;

      this.init();
    }

    init() {
      let countries = [];
      try {
        countries = JSON.parse(this.dataset.countries || '[]');
      } catch (error) {
        console.error('Country redirect popup: could not parse country data.', error);
        return;
      }

      const inEditor = window.Shopify && window.Shopify.designMode;

      if (inEditor) {
        // Preview the first configured country in the theme editor so
        // merchants can see and style the popup without spoofing geolocation.
        const match = countries[0];
        if (!match) return;
        this.match = match;
        this.render(match);
        this.show();
        this.bindEvents();
        return;
      }

      const baseCountry = (this.dataset.baseCountry || '').toUpperCase();
      const detected = (this.dataset.detectedCountry || '').toUpperCase();

      if (!detected || detected === baseCountry) return;
      if (this.getCookie(this.cookieName)) return;

      const match = countries.find((country) => country.code === detected);
      if (!match) return;

      this.match = match;
      this.render(match);
      this.bindEvents();

      const delay = (parseFloat(this.dataset.popupDelay, 10) || 0) * 1000;
      if (delay > 0) {
        window.setTimeout(() => this.show(), delay);
      } else {
        this.show();
      }
    }

    render(match) {
      const headingTemplate = this.heading.dataset.template || '';
      const bodyTemplate = this.body.dataset.template || '';

      this.heading.textContent = headingTemplate.replace('{country}', match.name);
      this.body.textContent = bodyTemplate.replace('{country}', match.name);

      if (match.flag) {
        this.flagImage.src = match.flag;
        this.flagImage.alt = match.name;
        this.flagImage.hidden = false;
        this.flagEmoji.hidden = true;
      } else {
        this.flagEmoji.textContent = this.isoToFlagEmoji(match.code);
        this.flagEmoji.hidden = false;
        this.flagImage.hidden = true;
      }
    }

    isoToFlagEmoji(code) {
      if (!code || code.length !== 2) return '';
      return code
        .toUpperCase()
        .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
    }

    bindEvents() {
      const redirect = () => this.redirect();
      this.acceptButton.addEventListener('click', redirect);
      this.flagButton.addEventListener('click', redirect);
      this.closeButton.addEventListener('click', () => this.dismiss());
      this.dismissButton.addEventListener('click', () => this.dismiss());
      this.overlay.addEventListener('click', () => this.dismiss());

      this.handleKeydown = (event) => {
        if (event.key === 'Escape') this.dismiss();
      };
      document.addEventListener('keydown', this.handleKeydown);
    }

    redirect() {
      this.setCookie(this.cookieName, 'redirected', this.cookieDays);
      if (this.match && this.match.redirect) {
        window.location.href = this.match.redirect;
      } else {
        this.hide();
      }
    }

    dismiss() {
      this.setCookie(this.cookieName, 'dismissed', this.cookieDays);
      this.hide();
    }

    show() {
      this.hidden = false;
      requestAnimationFrame(() => {
        this.classList.add('is-visible');
        this.dialog.focus();
      });
    }

    hide() {
      this.classList.remove('is-visible');
      document.removeEventListener('keydown', this.handleKeydown);
      window.setTimeout(() => {
        this.hidden = true;
      }, 350);
    }

    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;SameSite=Lax`;
    }

    getCookie(name) {
      const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }
  }

  customElements.define('country-redirect-popup', CountryRedirectPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
